/*
 * View for example locale
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicExampleModal/exampleLocale/template/exampleLocaleTemplate.html",
], function (Marionette, ExampleLocaleTemplate) {
  var ExampleLocaleView = {};

  ExampleLocaleView.exampleLocaleView = Marionette.ItemView.extend({
    template: ExampleLocaleTemplate,
    modelEvents: {
      sync: "render",
    },
    onRender: function () {
      this.$el.i18n();
    },
    getLocaleId: function () {
      return +this.$el.find("#exampleModalLocale").val();
    },
    triggers: {
      "change #exampleModalLocale": "change:locale",
    },
  });

  return ExampleLocaleView;
});
